import React, { useState } from 'react'
import { CustomDatePicker } from '../../../../components/formsComponents/CustomDatePicker';
import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Moment } from 'moment';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { RightPanel } from '../../../../components/RightPanel';
import { IMultipleEvent } from '../../../../redux/leads/leads.types';
import { Inventory } from '../../../Inventory/Inventory';
import { ControlledCustomSelect, CustomCheckbox } from '../../../../components/formsComponents';
import { CalendarMonth, Info } from '@mui/icons-material';
import { renderDropdownValue } from '../../../../helpers';


interface IEventDatePickerProps {
    values: IMultipleEvent
    disabled?: boolean
    onChange: (evt: IMultipleEvent) => void
    error?: string;
    type?: "calender" | "button"
}
export const EventDatePicker = ({
    values,
    onChange,
    disabled,
    error,
    type = "calender"
}: IEventDatePickerProps) => {
    const [openInventory, setOpenInventory] = useState<IMultipleEvent | null>(null);

    return (
        <>
            {type === "button" ? (
                <Button
                    type="button"
                    color='success'
                    variant="contained"
                    onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setOpenInventory(values);
                    }}
                >
                    <CalendarMonth sx={{ mr: 1 }} /> Reschedule
                </Button>
            ) : (
                <Box sx={{
                    width: "100%", display: "flex",
                    justifyContent: "space-between", alignItems: 'flex-start', gap: 0.2,
                    borderRadius: 0.5,
                }}>
                    {values.actual_status === "ONGOING" && (
                        <Box sx={{
                            display: "flex", flexDirection: "row",
                            justifyContent: "flex-start", alignItems: 'center', gap: 0.5,
                            borderRadius: 1,
                            mr: 0.5,
                            px: 0.5,
                            border: `1px solid ${disabled ? "#ccc" : "#e0e0e0"}`,
                            minHeight: 34,
                        }}>
                            <CustomCheckbox
                                sx={{
                                    p: 0,
                                }}
                                disabled={disabled}
                                checked={values.show_month_picker}
                                onChange={(evt, checkd) => {
                                    onChange({
                                        ...values,
                                        function_date: null,
                                        ...(!checkd && { function_month: null }),
                                        show_month_picker: checkd
                                    })
                                    setOpenInventory(null);
                                }}
                            />
                            <Tooltip
                                title="Not sure about the exact date? Select a month instead. This will help us in better planning and resource allocation for the event."
                                slotProps={{
                                    tooltip: {
                                        sx: {
                                            padding: 1.5,
                                            fontSize: 16,
                                            bgcolor: "primary.main",
                                            color: "#fff",
                                        }
                                    },
                                    arrow: {
                                        sx: {
                                            color: "primary.main",
                                        },
                                    },
                                }}
                                arrow
                            >
                                <Info
                                    sx={{
                                        p: 0,
                                        color: disabled ? "#bcbcbc" : "#878686",
                                    }}
                                />
                            </Tooltip>
                        </Box>
                    )}
                    {values.show_month_picker ? (
                        <ControlledCustomSelect
                            label="Event Month"
                            error={!!error}

                            variant="outlined"
                            size="small"
                            type="string"
                            name="function_month"
                            fullWidth
                            value={values.function_month || null}
                            disabled={disabled}
                            onChange={(e: any) => {
                                onChange({
                                    ...values,
                                    function_date: null,
                                    function_month: e.target.value,
                                })
                            }}
                            displayEmpty
                            renderValue={renderDropdownValue(
                                `Select One`,
                            )}
                            options={[
                                { label: "January", value: "January" },
                                { label: "February", value: "February" },
                                { label: "March", value: "March" },
                                { label: "April", value: "April" },
                                { label: "May", value: "May" },
                                { label: "June", value: "June" },
                                { label: "July", value: "July" },
                                { label: "August", value: "August" },
                                { label: "September", value: "September" },
                                { label: "October", value: "October" },
                                { label: "November", value: "November" },
                                { label: "December", value: "December" },
                            ]}
                        />
                    ) : (
                        <>
                            <CustomDatePicker
                                placeholder="Event Date"
                                fullWidth
                                value={values.function_date ?? null}
                                disabled={disabled || values.show_month_picker}
                                onChange={(newValue) => {
                                    let extractedMonth = "";
                                    if (newValue) {
                                        const date = new Date(newValue);
                                        extractedMonth = date.toLocaleString(
                                            "default",
                                            {
                                                month: "long",
                                            },
                                        );
                                    }
                                    onChange({
                                        ...values,
                                        function_date: newValue,
                                        function_month: extractedMonth,
                                    })
                                }}
                                errorMessage={error}
                            />
                            <IconButton
                                disabled={disabled || values.show_month_picker}
                                sx={{ p: 0 }}
                                onClick={(e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    setOpenInventory(values);
                                }}
                            >
                                <Tooltip title="Choose from Inventory">
                                    <CalendarMonthIcon
                                        sx={{
                                            fontSize: 36,
                                            color: disabled ? "#bcbcbc" : "#666",
                                            cursor: disabled ? "not-allowed" : 'pointer'
                                        }}
                                    />
                                </Tooltip>
                            </IconButton>
                        </>
                    )}
                </Box >
            )}

            {openInventory && (
                <RightPanel
                    open={true}
                    onClose={() => setOpenInventory(null)}
                    width="96%"
                    heading="Inventory Report"
                >
                    <Inventory eventLeadData={openInventory} isFromEventLead={true}
                        onSelectevent={(newEvent) => {
                            onChange({
                                ...openInventory,
                                ...newEvent,
                            })
                            setOpenInventory(null)
                        }}
                    />
                </RightPanel>
            )
            }

        </>
    )
}
